import type { ReactNode } from 'react';
import type { UsageSheetUse, UsageSheetUseRole } from '@shared/types/forge-usage-sheet';
import { SheetRow, SheetSection } from './SheetLines';
import { removeAt, replaceAt } from './sheet-edits';

const ROLE_GROUPS: Array<{ role: UsageSheetUseRole; title: string }> = [
  { role: 'search', title: 'Oriente la recherche' },
  { role: 'sort', title: 'Trie le résultat' },
  { role: 'write', title: 'Guide la rédaction' },
  { role: 'not_used', title: 'Pas utilisé' },
];

/**
 * « Ce que l'outil utilise » (21/10): each criterion or piece of data with
 * where it acts, so the user sees at once whether the profile, a connection or
 * an input narrows the search, sorts the result, or is left out.
 */
export const UsesSection = ({ uses, editable, showWhy, text, onChange }: {
  uses: UsageSheetUse[];
  editable: boolean;
  showWhy: boolean;
  text: (value: string, label: string, onSave: (value: string) => void) => ReactNode;
  onChange: (uses: UsageSheetUse[]) => void;
}) => (
  <SheetSection title="Ce que l’outil utilise">
    {ROLE_GROUPS.map(({ role, title }) => {
      const indexes = uses.flatMap((use, index) => (use.role === role ? [index] : []));
      if (indexes.length === 0) return null;
      return <div key={role} className="space-y-1">
        <p className="text-sm text-domino-inkSoft">{title}</p>
        {indexes.map((index) => {
          const use = uses[index]!;
          return <SheetRow key={`${index}:${use.label}`} showWhy={showWhy || role === 'not_used'} why={use.why}
            removeLabel={`Retirer ${use.label}`} onRemove={editable ? () => onChange(removeAt(uses, index)) : undefined}>
            {text(use.label, `Critère ${use.label}`, (label) => onChange(replaceAt(uses, index, { label })))}
            {use.from && <span className="text-domino-inkSoft"> · {use.from}</span>}
          </SheetRow>;
        })}
      </div>;
    })}
  </SheetSection>
);
